interface EventPayload {
    [key: string]: any
}
declare global {
    interface Window {
        gtag: (command: string, nameOrParams: string | EventPayload, params?: EventPayload) => void;
        posthog?: {
            capture: (name: string, properties?: EventPayload) => void;
            identify: (distinctId: string, properties?: EventPayload) => void;
            reset: () => void;
        };
    }
}

export function identifyAnalyticsUser(userId: string, properties?: EventPayload) {
    if (typeof window === "undefined") return;
    window.posthog?.identify(userId, properties);
}

export function resetAnalyticsUser() {
    if (typeof window === "undefined") return;
    window.posthog?.reset();
}

export function logEvent(name: string, payload?: EventPayload) {
    if (typeof window === "undefined") return;

    if (typeof window.gtag === "function") {
        window.gtag("event", name, payload);
    }

    if (window.posthog?.capture) {
        window.posthog.capture(name, payload);
    }
}
